// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"VideoBanner_cardWrapper__3cSXd"};